import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { ReduxStates } from '../../../redux/reduxTypes';

import Segment from '../../../components/Segment';
import { Status as StatusInterface, DateRange } from '../../../types';
import { fetchGlanceData, returnAmazonShareData } from './../helpers';

interface Props {
  dateRange: DateRange;
  setFetching: (fetching: boolean) => void;
  isShare?: boolean;
}

const AmazonShare = ({ dateRange, setFetching, isShare }: Props): React.ReactElement => {
  const [glanceShareData, setGlanceShareData] = useState<any>();
  const [status, setStatus] = useState<StatusInterface[]>([]);
  const copyData = useSelector((state: ReduxStates) => state.copyData);

  const fetchGlanceShare = async (params: any, path: string) => {
    setFetching(true);

    (async () => {
      try {
        const data = await fetchGlanceData(path, params);
        setGlanceShareData(data && returnAmazonShareData(data.amazon));
        setFetching(false);
      } catch (error: any) {
        setStatus([...status, { state: 'error', message: error }]);
        setFetching(false);
      }
    })();
  };

  useEffect(() => {
    //reset
    resetShareData();

    const params = {
      startDate: dateRange.startDate,
      endDate: dateRange.endDate
    };
    const path = 'atglance/share';
    if (isShare) {
      fetchGlanceShare(params, path);
    }
  }, []);

  const resetShareData = () => {
    setGlanceShareData(null);
  };

  return (
    <>
      {glanceShareData ? (
        glanceShareData.map((segment: any, index: number) => {
          return (
            <Segment
              key={`${index}-cs`}
              title={segment.title.toUpperCase()}
              totalValue={segment.currentValue}
              unit={segment.currentValueType === 'percentage' ? '%' : ''}
              currency={segment.currencyCode}
              WoW={segment.wowPercentage}
              last13={segment.l13wPercentage}
              last52={segment.l52wPercentage}
              displayData={['WoW', 'last13', 'last52']}
            />
          );
        })
      ) : (
        <div>
          {isShare ? (
            <p className="m-0 font-nunitoRegular text-fontBlock text-xs mb-[15px]">{copyData?.loading}</p>
          ) : (
            <p className="font-nunitoRegular text-fontBlock text-sm mb-[15px] w-full text-center">
              {copyData?.no_api_data}

              <a
                className="underline text-blue-500"
                href={'https://www.ascentialedge.com/demo-request3'}
                target="_blank"
              >
                {copyData?.talk_to_expert}
              </a>
            </p>
          )}
        </div>
      )}
    </>
  );
};

export default AmazonShare;
